const relatedSKUs = document
  .getElementById("list-of-related-products")
  .innerHTML.split(",")
  .map((product) => product.trim());

let filteredRealtedSkus = [...relatedSKUs];

const moneyFormat = document
  .getElementById("list-of-related-products")
  .getAttribute("data-money-format");

const fetchAllProducts = async () => {
  const products = [];

  for (let i = 1; i < 100; i++) {
    let isLastPage = false;
    await fetch(
      `${window.Shopify.routes.root}collections/ajax-collection?page=${i}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "text/html; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest",
          "Content-Security-Policy": "upgrade-insecure-requests",
        },
      }
    )
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, "text/html");
        const collectionAjax = htmlDoc.querySelector(
          "#collection-ajax .shopify-section #section-ajax-data"
        );

        if (collectionAjax.innerHTML.trim() === "{}") {
          isLastPage = true;
          return;
        }

        JsonedData = JSON.parse(collectionAjax.innerHTML);
        filteredRealtedSkus = filteredRealtedSkus.filter(
          (sku) => !JsonedData[sku]
        );
        products.push(JSON.parse(collectionAjax.innerHTML));
      })
      .catch((error) => console.error(error));
    if (filteredRealtedSkus.length === 0) break;
    if (isLastPage) break;
  }
  return products;
};

const fetchProducts = async () => {
  let productsArr = [];
  const data = await fetchAllProducts();
  await data.forEach((element) => {
    // loop through the keys in the element object
    for (const key in element) {
      // if the value is in the relatedSKUs array
      if (relatedSKUs.includes(key)) {
        // push the element into the productsArr
        productsArr.push(element[key]);
      }
    }
    if (relatedSKUs.includes(element.handle)) {
      productsArr.push(element);
    }
  });
  return productsArr;
};

const fromsListener = () => {
  const forms = document.querySelectorAll(
    ".related-products-form, .ajax-add-to-cart-form"
  );
  if (forms.length === 0) {
    return;
  }
  forms.forEach((form) => {
    formQty(form);
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const data = await ajaxAddToCart(form);
      const productData = getProductData(form);
      const cartData = await getCartData();
      atcBanner(productData, cartData);
    });
  });
};

const hideServerRenderedData = () => {
  const serverRenderedData = document.querySelectorAll(
    ".meta-related-products__products.server-rendered-metafields"
  );
  const serverRenderedDataMobile = document.querySelectorAll(
    ".server-render-data-mobile"
  );
  serverRenderedData.forEach((data) => {
    data.style.display = "none";
  });
  serverRenderedDataMobile.forEach((data) => {
    data.style.display = "none";
  });

  const hidenBeforeAjax = document.querySelectorAll(".hide-before-ajax");
  hidenBeforeAjax.forEach((data) => {
    data.style.display = "block";
  });

  const loadingSpinners = document.querySelectorAll(
    ".loading-related-products"
  );
  loadingSpinners.forEach((spinner) => {
    spinner.style.display = "none";
  });
};

const renderData = async () => {
  const products = await fetchProducts();

  const relatedProdTables = document.querySelectorAll(".js-product-table");
  relatedProdTables.forEach((table) => {
    const skus = table.getAttribute("data-skus").split(",");
    table.innerHTML = `${skus
      .map((sku) => {
        const product = products.find(
          (product) => product.handle === sku.trim()
        );
        if (!product) return "";
        return tableHtml(product);
      })
      .join("")}</tr>`;
  });

  const relatedProdMobiles = document.querySelectorAll(
    ".meta-related-products-mob__products.js-related-products-mobile"
  );
  relatedProdMobiles.forEach((mobileProd) => {
    const skus = mobileProd.getAttribute("data-skus").split(",");
    mobileProd.innerHTML = `${skus
      .map((sku) => {
        const product = products.find(
          (product) => product.handle === sku.trim()
        );
        if (!product) return "";
        return mobileHtml(product);
      })
      .join("")}</tr>`;
  });

  fromsListener();
  hideServerRenderedData();
};

renderData();

const priceHTML = (price) => {
  const priceExVAT = Shopify.formatMoney(
    (Number(price.replace(/[^0-9,.]/g, "")) / 1.2).toFixed(2),
    moneyFormat
  );
  let vatIncluded;
  if ("vatIncluded" in sessionStorage)
    vatIncluded = sessionStorage.getItem("vatIncluded");
  else vatIncluded = "false";

  if (vatIncluded == "true") {
    return `<div class="price__inc-vat price-vat--primary">
              <div>${price}</div>
              <div class="vat-text">Inc VAT</div>
            </div>
            <div class="price__ex-vat price-vat--secondary">
              <div>${priceExVAT}</div>
              <div class="vat-text">Exc VAT</div>
            </div>`;
  } else {
    return `<div class="price__inc-vat price-vat--secondary">
              <div>${price}</div>
              <div class="vat-text">Inc VAT</div>
            </div>
            <div class="price__ex-vat price-vat--primary">
              <div>${priceExVAT}</div>
              <div class="vat-text">Exc VAT</div>
            </div>`;
  }
};

const tableHtml = (product) => {
  const productPrice = priceHTML(product.price);

  return `<tr class="meta-related-products__product">
  <td class="meta-related-products__product-img-td">
    <a href="${product.url}">
      <img
        class="meta-related-products__product-img"
        src="${product.image}"
        loading="lazy"
        width="80"
        height="80"
        alt="${product.title}"
      >
    </a>
  </td>
  <td class="meta-related-products__product-sku">
    <a href="/products/${product.handle}"> ${product.sku} </a>
  </td>
  <td class="meta-related-products__product-title">
    <a href="/products/${product.handle}"> ${product.title} </a>
  </td>
  <td class="meta-related-products__product-price prices-container">
    ${productPrice}
  </td>
  <td class="meta-related-products__product-delivery">${`
      <span class="${
        product.is_item_in_stock == true ? "item-in-stock" : "item-out-of-stock"
      }">
      ${
        product.is_special_offer == true && product.is_item_in_stock == false
          ? `<span class='product-delivery-status item-is-special'>{{ special_offer }}</span>`
          : `${product.stock_status}`
      }
      </span>
      
    `}</td>
  <td class="meta-related-products__product-link-td">
    <form
      method="post"
      action="/cart/add"
      id="product_form_6556406055117"
      accept-charset="UTF-8"
      class="related-products-form"
      enctype="multipart/form-data"
      data-product-form=""
    >
      <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">

      <variant-selection
        class="variant-selection"
        product-url="/products/${product.handle}.js"
        variant="${product}"
        data-variant-selection="${product.variant_id}"
      >
        <input
          class="variant-selection__variants variant-selection__variants--default"
          name="id"
          type="hidden"
          value="${product.variant_id}"
          data-variants=""
        >
      </variant-selection>

      <div class="product-form--atc">
        <div class="product-form__action-wrapper">
          <quantity-selector class="quantity-selector" data-quantity-selector="">
            <label
              class="quantity-selector__label"
              for="quantity-selector__input-template--15754565255373__96a71d2f-2bbc-4b03-b7d6-780e288ba7f1"
              >Quantity</label
            >

            <div class="quantity-selector__wrapper">
              <div
                class="
                  quantity-selector__button-wrapper
                  quantity-selector__button-wrapper--minus
                  quantity-selector__button-wrapper--disabled
                "
                data-button-wrapper=""
                data-button-wrapper-minus=""
              >
                <button
                  class="
                    quantity-selector__button
                    qty-selector__btn--minus
                  "
                  type="button"
                  name="minus"
                  aria-label="Decrease quantity by 1"
                >
                  <svg width="10" height="2" viewBox="0 0 10 2" fill="none">
                    <rect width="10" height="2" fill="currentColor"></rect>
                  </svg>
                </button>
              </div>

              <input
                class="quantity-selector__input"
                id="quantity-selector__input-template--15754565255373__96a71d2f-2bbc-4b03-b7d6-780e288ba7f1"
                aria-label="Quantity"
                name="quantity"
                type="number"
                min="1"
                step="1"
                value="1"
                data-quantity-input=""
                data-increment-value="1"
              >

              <div class="        quantity-selector__button-wrapper" data-button-wrapper="">
                <button
                  class="
                    quantity-selector__button
                    qty-selector__btn--plus
                  "
                  type="button"
                  aria-label="Increase quantity by 1"
                >
                  <svg
                    class="icon-plus "
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6L4 10H6V6H10V4H6V0H4L4 4H0V6H4Z" fill="currentColor"></path>
                  </svg>
                </button>
              </div>
            </div>
          </quantity-selector>

          <button
            class="
              product-form--atc-button
              related-products-add-to-cart
              ${product.variant_avaible == true ? "" : "disabled"}
            "
            type="submit"
            data-product-atc=""
            ${product.variant_avaible == true ? "" : "disabled"}
          >
            <span class="atc-button--text">
              <span class="cart-icon">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="presentation"
                  width="28"
                  height="26"
                  viewBox="0 10 28 26"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="currentColor" fill-rule="evenodd" d="M26.15 14.488L6.977 13.59l-.666-2.661C6.159 10.37 5.704 10 5.127 10H1.213C.547 10 0 10.558 0 11.238c0 .68.547 1.238 1.213 1.238h2.974l3.337 13.249-.82 3.465c-.092.371 0 .774.212 1.053.243.31.576.465.94.465H22.72c.667 0 1.214-.558 1.214-1.239 0-.68-.547-1.238-1.214-1.238H9.434l.333-1.423 12.135-.589c.455-.03.85-.31 1.032-.712l4.247-9.286c.181-.34.151-.774-.06-1.144-.212-.34-.577-.589-.97-.589zM22.297 36c-1.256 0-2.275-1.04-2.275-2.321 0-1.282 1.019-2.322 2.275-2.322s2.275 1.04 2.275 2.322c0 1.281-1.02 2.321-2.275 2.321zM10.92 33.679C10.92 34.96 9.9 36 8.646 36 7.39 36 6.37 34.96 6.37 33.679c0-1.282 1.019-2.322 2.275-2.322s2.275 1.04 2.275 2.322z"></path>
                </svg>
              </span>
              ${product.variant_avaible == true ? "Add to cart" : "Sold out"}
            </span>
            <span class="atc-button--icon">
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill-rule="nonzero" fill="currentColor">
                <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path>
                </g>
              </svg>
            </span>
          </button>
        </div>
      </div>

      <div data-payment-terms-reference="" style="display: none;"></div>

      <div class="surface-pick-up" data-surface-pick-up=""></div>
    </form>
  </td>
</tr>`;
};

const mobileHtml = (product) => {
  const productPrice = priceHTML(product.price);

  return `<div class="meta-related-products-mob__product">
  <div class="meta-related-products-mob__img">
    <a href="/products/${product.handle}">
      <img
        src="${product.image}"
        loading="lazy"
        width="80"
        height="80"
        alt="${product.title}"
      >
    </a>
  </div>
  <div class="meta-related-products-mob__info">
    <h3 class="meta-related-products-mob__name meta-related-products__product-title">
      <a href="/products/${product.handle}">${product.title}</a>
    </h3>
    <div class="meta-related-products-mog__group-box">
      <div class="meta-related-products-mob__price">
        <span class="meta-related-products-mob__price--current meta-related-products__product-price prices-container">
          ${productPrice}
        </span>
      </div>

      <div class="meta-related-products__product-delivery">
      ${`<span class="${
        product.is_item_in_stock == true ? "item-in-stock" : "item-out-of-stock"
      }">
        ${
          product.is_special_offer == true && product.is_item_in_stock == false
            ? `<span class='product-delivery-status item-is-special'>{{ special_offer }}</span>`
            : `${product.stock_status}`
        }
        </span>
        
      `}
      </div>
    </div>

    <div class="quickshop-product__box">
      <div class="quickshop-product__content">
        <form
          method="post"
          action="/cart/add"
          id="product_form_6852265345229"
          accept-charset="UTF-8"
          class="ajax-add-to-cart-form"
          enctype="multipart/form-data"
          data-product-form=""
        >
          <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">

          <variant-selection
            class="variant-selection"
            product-url="/products/${product.handle}.js"
            variant="${product.variant_id}"
            data-variant-selection=""
          >
            <input
              class="variant-selection__variants variant-selection__variants--default"
              name="id"
              type="hidden"
              value="${product.variant_id}"
              data-variants=""
            >
          </variant-selection>

          <div class="product-form--atc">
            <div class="product-form__action-wrapper">
              <quantity-selector class="quantity-selector" data-quantity-selector="">
                <label
                  class="quantity-selector__label"
                  for="quantity-selector__input-template--15754565255373__96a71d2f-2bbc-4b03-b7d6-780e288ba7f1"
                  >Quantity</label
                >

                <div class="quantity-selector__wrapper">
                  <div
                    class="
                      quantity-selector__button-wrapper
                      quantity-selector__button-wrapper--minus
                      quantity-selector__button-wrapper--disabled
                    "
                    data-button-wrapper=""
                    data-button-wrapper-minus=""
                  >
                    <button
                      class="
                        quantity-selector__button
                        qty-selector__btn--minus
                      "
                      type="button"
                      name="minus"
                      aria-label="Decrease quantity by 1"
                    >
                      <svg width="10" height="2" viewBox="0 0 10 2" fill="none">
                        <rect width="10" height="2" fill="currentColor"></rect>
                      </svg>
                    </button>
                  </div>

                  <input
                    class="quantity-selector__input"
                    id="quantity-selector__input-template--15754565255373__96a71d2f-2bbc-4b03-b7d6-780e288ba7f1"
                    aria-label="Quantity"
                    name="quantity"
                    type="number"
                    min="1"
                    step="1"
                    value="1"
                    data-quantity-input=""
                    data-increment-value="1"
                  >

                  <div
                    class="quantity-selector__button-wrapper"
                    data-button-wrapper=""
                  >
                    <button
                      class="
                        quantity-selector__button
                        qty-selector__btn--plus
                      "
                      type="button"
                      aria-label="Increase quantity by 1"
                    >
                      <svg
                        class="icon-plus "
                        aria-hidden="true"
                        focusable="false"
                        role="presentation"
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                      >
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6L4 10H6V6H10V4H6V0H4L4 4H0V6H4Z" fill="currentColor"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </quantity-selector>

              <button
                class="product-form--atc-button ${
                  product.variant_avaible == true ? "" : "disabled"
                }"
                type="submit"
                data-product-atc=""
                ${product.variant_avaible == true ? "" : "disabled"}
              >
                <span class="atc-button--text"> 
                  ${
                    product.variant_avaible == true ? "Add to cart" : "Sold out"
                  }
                </span>
                <span class="atc-button--icon">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill-rule="nonzero" fill="currentColor">
                    <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path>
                    </g>
                  </svg>
                </span>
              </button>
            </div>
          </div>

          <div data-payment-terms-reference="" style="display: none;"></div>
        </form>
      </div>
      <div class="js-loading-gear">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="margin: auto; background: none; display: block; shape-rendering: auto;"
          width="200px"
          height="200px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <g transform="translate(50 50)">
          <g>
          <animateTransform attributeName="transform" type="rotate" values="0;45" keyTimes="0;1" dur="0.2s" repeatCount="indefinite"></animateTransform><path d="M29.491524206117255 -5.5 L37.491524206117255 -5.5 L37.491524206117255 5.5 L29.491524206117255 5.5 A30 30 0 0 1 24.742744050198738 16.964569457146712 L24.742744050198738 16.964569457146712 L30.399598299691117 22.621423706639092 L22.621423706639096 30.399598299691114 L16.964569457146716 24.742744050198734 A30 30 0 0 1 5.5 29.491524206117255 L5.5 29.491524206117255 L5.5 37.491524206117255 L-5.499999999999997 37.491524206117255 L-5.499999999999997 29.491524206117255 A30 30 0 0 1 -16.964569457146705 24.742744050198738 L-16.964569457146705 24.742744050198738 L-22.621423706639085 30.399598299691117 L-30.399598299691117 22.621423706639092 L-24.742744050198738 16.964569457146712 A30 30 0 0 1 -29.491524206117255 5.500000000000009 L-29.491524206117255 5.500000000000009 L-37.491524206117255 5.50000000000001 L-37.491524206117255 -5.500000000000001 L-29.491524206117255 -5.500000000000002 A30 30 0 0 1 -24.742744050198738 -16.964569457146705 L-24.742744050198738 -16.964569457146705 L-30.399598299691117 -22.621423706639085 L-22.621423706639092 -30.399598299691117 L-16.964569457146712 -24.742744050198738 A30 30 0 0 1 -5.500000000000011 -29.491524206117255 L-5.500000000000011 -29.491524206117255 L-5.500000000000012 -37.491524206117255 L5.499999999999998 -37.491524206117255 L5.5 -29.491524206117255 A30 30 0 0 1 16.964569457146702 -24.74274405019874 L16.964569457146702 -24.74274405019874 L22.62142370663908 -30.39959829969112 L30.399598299691117 -22.6214237066391 L24.742744050198738 -16.964569457146716 A30 30 0 0 1 29.491524206117255 -5.500000000000013 M0 -20A20 20 0 1 0 0 20 A20 20 0 1 0 0 -20" fill="#b1b1b1"></path></g></g>
          <!-- [ldio] generated by https://loading.io/ -->
        </svg>
      </div>
    </div>
  </div>
</div>`;
};
